var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoHead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 325,
    height: 308,
    viewBox: "0 0 325 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2263_6496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.78 225.26L72.66 215.51C73.6 229.53 77.28 243.5 83.82 256.6C73.83 254.39 64.59 248.59 58.25 239.56C58.25 239.56 51.76 230.94 58.78 225.27V225.26Z",
    fill: "#FF007E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.66 215.5L102.58 194.48C108.96 189.99 115.66 186.3 122.56 183.36L99.34 150.31C96.76 146.64 91.24 146.74 88.87 150.54C76.74 170.01 71.14 192.82 72.66 215.5Z",
    fill: "#FBD7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.66 215.5C73.6 229.52 77.28 243.49 83.82 256.59C95.05 259.07 107.25 257.01 117.4 249.87C136.59 236.39 141.21 209.9 127.73 190.71L122.56 183.35C115.66 186.29 108.96 189.99 102.58 194.47L72.66 215.49V215.5Z",
    fill: "#00F2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.22 68.59C220.928 68.59 242.58 46.9385 242.58 20.23C242.58 -6.47849 220.928 -28.13 194.22 -28.13C167.512 -28.13 145.86 -6.47849 145.86 20.23C145.86 46.9385 167.512 68.59 194.22 68.59Z",
    fill: "#7C8CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.22 41.98C206.232 41.98 215.97 32.2422 215.97 20.23C215.97 8.21779 206.232 -1.52002 194.22 -1.52002C182.208 -1.52002 172.47 8.21779 172.47 20.23C172.47 32.2422 182.208 41.98 194.22 41.98Z",
    fill: "#28304A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.13 160.3C54.1245 160.3 66.28 148.145 66.28 133.15C66.28 118.155 54.1245 106 39.13 106C24.1355 106 11.98 118.155 11.98 133.15C11.98 148.145 24.1355 160.3 39.13 160.3Z",
    fill: "#7C8CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.13 145.36C45.8734 145.36 51.34 139.893 51.34 133.15C51.34 126.407 45.8734 120.94 39.13 120.94C32.3866 120.94 26.92 126.407 26.92 133.15C26.92 139.893 32.3866 145.36 39.13 145.36Z",
    fill: "#28304A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.85 192.33C193.845 192.33 206 180.175 206 165.18C206 150.185 193.845 138.03 178.85 138.03C163.855 138.03 151.7 150.185 151.7 165.18C151.7 180.175 163.855 192.33 178.85 192.33Z",
    fill: "#7C8CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.85 177.39C185.593 177.39 191.06 171.923 191.06 165.18C191.06 158.437 185.593 152.97 178.85 152.97C172.107 152.97 166.64 158.437 166.64 165.18C166.64 171.923 172.107 177.39 178.85 177.39Z",
    fill: "#28304A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 95.64L77.68 60.01L33.8 -3.37C3.17 17.83 -7.35 57.24 6.73 90.22C6.73 90.22 13.4 104.49 26.19 95.64H26.2Z",
    fill: "#F9C638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.95 -42.17L33.83 -3.33L77.7 60.06C110.3 37.5 120.12 -5.7 101.75 -39.8C101.75 -39.8 97.48 -47.38 89.96 -42.17H89.95Z",
    fill: "#7C8CF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.41 135.75L161.17 103.39C166.43 99.75 167.74 92.53 164.1 87.27L131.45 40.1C128.23 35.44 121.59 34.54 117.4 38.35C91.22 62.16 84.11 100.75 100.02 132.31C100.02 132.31 104.74 142.43 114.4 135.75H114.41Z",
    fill: "#FF007E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.84 112.42L305.7 33.01C306.85 26.41 301.1 20.67 294.49 21.81C266.68 26.61 243.58 48.35 238.45 77.75L224.59 157.16C223.44 163.76 229.19 169.5 235.8 168.36C263.61 163.56 286.71 141.81 291.84 112.42Z",
    fill: "#00F2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.6 276.9C106.92 282.29 108.26 294.13 117 297.54C162.86 315.4 216.51 310.71 259.79 280.3C303.13 249.84 325.7 200.86 324.35 151.6C324.09 141.99 313.08 136.65 305.42 142.47C301.67 145.32 297.85 148.11 293.96 150.85L114.59 276.91L114.6 276.9Z",
    fill: "#F9C638"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2263_6496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323.84,
    height: 351.97,
    fill: "white",
    transform: "translate(0.580002 -44)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHead);
export default __webpack_public_path__ + "static/media/ico_head.89111941f9643840dcbefc782e838575.svg";
export { ForwardRef as ReactComponent };